export const uppercase = function(str: string) {
  if (!str) return ''
  return str.toUpperCase()
}
export const capitalize = function(str: string) {
  if (!str) return ''
  return str.charAt(0).toUpperCase() + str.slice(1)
}